import React from "react";
import { motion } from "framer-motion";
import { ImgAurobilcarsLight, ImgMazda, loginBg } from "../../assets/images";
import styled from "styled-components";
import useScreenSize from "../../hooks/useScreenSize";
import LoginForm from "./LoginForm";

const LoginPage = () => {
  const { isLg, isXl, isXxl, isXxxl } = useScreenSize();

  return (
    <PageContainer className="d-flex">
      <LeftPanel
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="vh-100 d-none d-lg-block"
      >
        <LeftPanelContainer className="" style={{ backgroundImage: `url(${loginBg})` }}>
          <CarContainer
            className="position-relative"
            layout
            initial={{
              x: 0,
              y: isXxxl ? 200 : isXxl ? 200 : isXl ? 180 : isLg ? 140 : 200,
              opacity: 1,
              scale: 0.8
            }}
            animate={{
              x: isXxxl ? 200 : isXxl ? 150 : isXl ? 110 : isLg ? 70 : 150,
              y: isXxxl ? 210 : isXxl ? 210 : isXl ? 220 : isLg ? 180 : 210,
              opacity: 1,
              scale: 1
            }}
            transition={{ duration: 1, delay: 0.5 }}
            style={{
              backgroundImage: `url(${ImgMazda})`,
              width: "100%",
              height: "350px",
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }}
          />
        </LeftPanelContainer>
      </LeftPanel>

      <RightPanel className="vh-100 d-flex flex-column align-items-center">
        <LoginContainer className="text-center mt-5 card">
          <div className="card-body">
            <Logo
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              className="m-auto"
              style={{ backgroundImage: `url(${ImgAurobilcarsLight})` }}
            />
            <h4>Sign in to your account</h4>
            <p>Enter your details to proceed further</p>
            <LoginForm />
          </div>
        </LoginContainer>
      </RightPanel>
    </PageContainer>
  );
};

export default LoginPage;

const LeftPanel = styled(motion.div)`
  flex: 1;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  align-content: center;
`;

const LeftPanelContainer = styled.div`
  height: 90%;
  width: 70%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  margin-left: auto;
  border-radius: 20px;
  width: 90%;

  @media (min-width: 992px) {
    width: 90%;
  }

  @media (min-width: 1200px) {
    width: 90%;
  }

  @media (min-width: 1400px) {
    width: 75%;
  }
`;

const RightPanel = styled.div`
  flex: 1;
`;

const LoginContainer = styled.div`
  background-color: #ffffff94;
  border: 0;
  border-radius: 0;
  width: 95% !important;

  @media (min-width: 460px) {
    width: 80% !important;
  }

  @media (min-width: 576px) {
    width: 70% !important;
  }

  @media (min-width: 768px) {
    width: 50% !important;
  }

  @media (min-width: 992px) {
    width: 70% !important;
  }

  @media (min-width: 1200px) {
    width: 65% !important;
  }

  @media (min-width: 1400px) {
    width: 55% !important;
  }
`;

const Logo = styled(motion.div)`
  width: 150px;
  height: 150px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`;

const CarContainer = styled(motion.div)`
  pointer-events: none;
`;

const PageContainer = styled.div`
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
`;
